import { z } from "zod";

const scheduleTypes = ["EveryDay", "DayOfWeek", "DayOfMonth"] as const;
export const scheduleTypeSchema = z.enum(scheduleTypes);
export type ScheduleType = z.infer<typeof scheduleTypeSchema>;

const dateFilterPresets = [
	"Yesterday",
	"Last7Days",
	"Last30Days",
	"LastCalendarMonth",
	"CurrentCalendarMonth",
] as const;
export const dateFilterPresetSchema = z.enum(dateFilterPresets);
export type DateFilterPreset = z.infer<typeof dateFilterPresetSchema>;

export const scheduledReportSchema = z.object({
	id: z.string().optional(),
	tenantId: z.string().optional(),
	salesforceTenantId: z.string().nullable().optional(),
	userId: z.string().nullable().optional(),
	userName: z.string().nullable().optional(),
	canUnsubscribe: z.boolean().optional(),
	alias: z.string().nullable().optional(),
	reportType: z.string().nullable().optional(),
	scheduleType: scheduleTypeSchema.optional(),
	dayOfMonth: z.number().nullable().optional(),
	dayOfWeek: z.number().nullable().optional(),
	dateFilterPreset: dateFilterPresetSchema.optional(),
	machineIds: z.array(z.string()).nullable().optional(),
	usePlannedProduction: z.boolean().optional(),
	isDisabled: z.boolean().optional(),
	emailAddresses: z.array(z.string()).nullable().optional(),
	updated: z.string().optional(),
	lastRun: z.string().nullable().optional(),
	tenantName: z.string().nullable().optional(),
});

export type ScheduledReport = z.infer<typeof scheduledReportSchema>;
